import request from "@/utils/request";

// 登录
export const Login = (data) =>
  request({
    url: "/urinePC/auth/login",
    method: "post",
    data,
  });

// 注册方法
export function register(data) {
  return request({
    url: "/urinePC/auth/register",
    headers: {
      isToken: false,
    },
    method: "post",
    data: data,
  });
}

// 刷新方法
export function refreshToken() {
  return request({
    url: "/urinePC/auth/refresh",
    method: "post",
  });
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: "/urinePC/system/user/getInfo",
    method: "get",
  });
}

// 退出方法
export function logout() {
  return request({
    url: "/urinePC/auth/logout",
    method: "delete",
  });
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: "/urinePC/code",
    method: "get",
  });
}

// 获取账号信息
export function getUser() {
  return request({
    url: "/urinePC/system/user/getInfo",
    method: "get",
  });
}

//---------------------------------------------

// 登录-获取验证码
export const getCaptchaRender = (params) => {
  return request({
    url: `/urinePC/captcha/render`,
    method: "get",
  });
};

// 登录-获取token
export const postAuthLogin = (data) => {
  return request({
    url: `/urinePC/auth/login`,
    method: "post",
    data,
  });
};

// 退出登录
export const postAuthLogout = () => {
  return request({
    url: `/urinePC/auth/logout`,
    method: "post",
  });
};
